export const font = {
    PRIMARY: 'Roboto, sans-serif'
}